<ui-button
  [variant]="variant()"
  [size]="size()"
  [class]="class()"
  [fitContent]="fitContent()"
  [disabled]="disabled()"
  [label]="label()"
  (onClick)="onClick.emit($event)">
  <fa-icon [icon]="iconMap[icon()]" />
</ui-button>
